import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useFormState from '../../../../../../hooks/useFormState'
import CenteredModal from '../../../../../common/CenteredModal'
import { SelectField } from '../../../../../common/FormFields'
import validationConfig from './validationConfig'
import { toast } from 'react-toastify'
import { startSyncApplictionsJob } from '../../../../../../redux/actions/application'
import { getAllPlatforms } from '../../../../../../redux/actions/lookupData'

const SyncApplicationsModal = ({ isVisible, setIsVisible }) => {

  // ===== Hooks =====
  const formState = useFormState()
  const { formData, formErrors, validateForm, validateFormField, onFormDataChanged } = formState

  // ===== Redux state =====
  const dispatch = useDispatch()
  const allPlatforms = useSelector(({ lookupData }) => lookupData.allPlatforms)
  const isStartingSyncJob = useSelector(({ application }) => application.isStartingSyncJob)

  // ===== Side effects =====
  useEffect(() => {
    if (allPlatforms?.length === 0) {
      dispatch(getAllPlatforms())
    }
  }, [])

  // ===== Methods =====
  const onChange = (key, value) => {
    onFormDataChanged(key, value)
    validateFormField(key, value, validationConfig)
  }

  const onSyncPressed = async () => {
    const isFormValid = validateForm(validationConfig)

    if (!isFormValid) {
      toast.error('Please choose a platform')
      return false
    }

    const platformCode = formData["platformCode"]
    const res = await dispatch(startSyncApplictionsJob(platformCode))

    if (res) {
      toast.success('Sync applications job successfully started!')
      setIsVisible(false)
    } else {
      toast.error('Oh dang it, something went wrong. Could you try again please?')
      return false
    }
  }

  return (
    <CenteredModal
      show={isVisible}
      onHide={() => setIsVisible(false)}
      title="Sync Applications"
      successBtnText={isStartingSyncJob ? "Starting Job..." : "Start Sync Job"}
      onSuccess={onSyncPressed}
      btnDisabled={isStartingSyncJob}
      cancelBtnText="Close"
    >
      <div className="sync-applications-modal-container">
        <SelectField
          displayName="Please choose platform"
          placeholder="Select platform"
          options={allPlatforms}
          onChange={(value) => onChange("platformCode", value)}
          disabled={isStartingSyncJob}
          value={formData["platformCode"]}
          errorMessage={formErrors["platformCode"]?.message}
        />
        <p><i className="fa fa-info-circle" /> Applications will be synced from the License Portal of selected platform</p>
      </div>
    </CenteredModal>
  )
}

export default SyncApplicationsModal
